import React from "react";
import { useLang } from "../../context/LangContext";
import { translations } from "../../lib/i18n";

const Footer = () => {
  const { lang } = useLang();
  const t = translations[lang];
  const year = new Date().getFullYear();

  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#0a0c0e] border-t border-white/5 pt-16 pb-10">
      <div className="rp-container">
        <div className="grid grid-cols-12 gap-8 pb-12 border-b border-white/5">
          <div className="col-span-12 md:col-span-5">
            <div className="font-display font-extrabold text-white text-3xl md:text-4xl tracking-tight leading-none">
              ROBERT
              <br />
              PRIETO
            </div>
            <div className="mt-4 text-[11px] tracking-[0.28em] uppercase text-[color:var(--rp-muted)]">
              {t.footer.role}
            </div>
          </div>
          <div className="col-span-6 md:col-span-3">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">
              Navigation
            </div>
            <ul className="space-y-2 text-sm text-[color:var(--rp-muted)]">
              {["profile", "career", "goalkeepers", "methodology", "education", "contact"].map((k) => (
                <li key={k}>
                  <button onClick={() => go(k)} className="hover:text-white transition-colors capitalize">
                    {t.nav[k]}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-span-6 md:col-span-4">
            <div className="text-[10px] tracking-[0.3em] uppercase text-white/40 mb-4">Contact</div>
            <ul className="space-y-2 text-sm text-[color:var(--rp-muted)]">
              <li>
                <a href="mailto:robertpd13@hotmail.com" className="hover:text-white transition-colors">
                  robertpd13@hotmail.com
                </a>
              </li>
              <li>
                <a href="tel:+56954081865" className="hover:text-white transition-colors">
                  +56 9 54081865
                </a>
              </li>
              <li className="pt-2">
                <a href="/admin/login" className="text-[10px] tracking-[0.28em] uppercase text-white/30 hover:text-white/60">
                  Admin
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] tracking-[0.2em] uppercase text-[color:var(--rp-muted)]">
          <div>© {year} Robert Prieto Deuma. {t.footer.rights}</div>
          <div>Santiago · Chile</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
